import { Truck, MapPin } from 'lucide-react';
import { OohCourierTrip } from '../../../../core/graphql/types';
import { calculateCourierCharges } from '../../../../core/utils/ooh/oohCalculations';
import { useOohState } from '../../../../core/hooks/ooh/useOohState';
import CourierChargesSection from './CourierChargesSection';
import DeliveryTripsSection from './DeliveryTripsSection';
import CourierTotalsSection from './CourierTotalsSection';

export interface CourierCardProps {
  courierTrip: OohCourierTrip;
  courierClickHandler: (courierId: number) => void;
  selectedCourierId: number | null;
}

const CourierCard = ({
  courierTrip,
  courierClickHandler,
  selectedCourierId,
}: CourierCardProps) => {
  const { expandedTrips, toggleTripExpansion } = useOohState();

  const totalCourierCharges = calculateCourierCharges(courierTrip);



  return (
    <div className="my-4 border p-4 shadow-lg transition-all duration-300 hover:shadow-xl">
      <div className="flex justify-between">
        <div className="mb-6 flex items-center gap-3">
          <div className="rounded-lg  bg-light-blue p-2 dark:bg-night-dark-blue">
            <Truck className="text-dark-blue h-4 w-4 " />
          </div>
          <h2 className="text-xl font-bold dark:text-white">
            {courierTrip.indicative}
          </h2>
        </div>

        <button
          className="flex h-10 items-center gap-2 rounded-lg bg-bright-blue px-4 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-bright-blue/90"
          onClick={() => courierClickHandler(courierTrip.courierId)}
        >
          <MapPin className="h-4 w-4" />
          {selectedCourierId !== null &&
          selectedCourierId === courierTrip.courierId
            ? 'Hide location on map'
            : 'Display position on map'}
        </button>
      </div>

      <div className="mb-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <CourierChargesSection agencyCourierVisits={courierTrip.agencyCourierVisits} />
        <DeliveryTripsSection 
          locationTrips={courierTrip.locationTrips}
          expandedTrips={expandedTrips}
          onToggleTripExpansion={toggleTripExpansion}
        />
      </div>
      <CourierTotalsSection
        totalCourierCharges={totalCourierCharges}
        courierTotals={courierTrip.courierTotals}
      />
    </div>
  );
};

export default CourierCard;
